import { Component, Inject } from '@angular/core';
import { CookieConsentFacade } from '@planone/shared/feature-cookie-consent';
import { COOKIEHANDLING_SERVICE, CookiehandlingServiceInterface } from '@planone/shared/util-cookie-handling';

@Component({
  selector: 'planone-youtube-video-cookie-consent-overlay',
  templateUrl: './youtube-video-cookie-consent-overlay.component.html',
  styleUrls: ['./youtube-video-cookie-consent-overlay.component.scss'],
})
export class YoutubeVideoCookieConsentOverlayComponent {
  acceptedCookieConsent = false;

  constructor(
    @Inject(COOKIEHANDLING_SERVICE) private cookiehandlingService: CookiehandlingServiceInterface,
    private cookieConsentFacade: CookieConsentFacade
  ) {}

  acceptCookieConsent() {
    this.acceptedCookieConsent = true;

    this.cookiehandlingService.write('CookieConsent', 'allow');

    this.cookieConsentFacade.change(true);
  }
}
